import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie';
import { getCookie, getLocalStorageItem } from '../../utils/Utils';
import { useTranslation } from 'react-i18next';
import SignoutHandler from '../SignoutHandler';
const PopupModal = ({ isOpen,
  message,
  onCancel,
  cancelText,
  confirmText }) => {
  const Navigate = useNavigate()
  const { t } = useTranslation();
  const { SelectVendor, Confirm, Cancel } = t('userprofile');
  const user = JSON.parse(localStorage?.getItem('userDataArray'))
  const selected = JSON.parse(localStorage?.getItem('userData'))
  const [isDragging, setIsDragging] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [offset, setOffset] = useState({ x: 0, y: 0 })
  const [selectedVendor, setSelectedVendor] = useState("")
  // Center the modal on mount
  useEffect(() => {
    const centerModal = () => {
      const modalWidth = document.querySelector('.modal-content').offsetWidth
      const modalHeight = document.querySelector('.modal-content').offsetHeight

      setPosition({
        x: (window.innerWidth - modalWidth) / 2,
        y: (window.innerHeight - modalHeight) / 2
      })
    }

    if (isOpen) {
      centerModal()
    }
  }, [isOpen])

  const onChangeRadio = (e) => {
    setSelectedVendor(e?.target?.value)
  }
  const onConfirm = () => {
    let selectedUser = {}
    user?.map((u) => {
      if (Number(u?.supplierId) === Number(selectedVendor))
        selectedUser = u
      return
    })

    localStorage.setItem("userData", JSON.stringify(selectedUser));
    onCancel()
    if (window.location.pathname === "/vendor")
      window.location.reload()
    else
      setTimeout(() => {
        Navigate("/vendor")
      }, 1000);
  }

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging) {
        const maxX = window.innerWidth - 420 // Adjust based on the width of your modal
        const maxY = window.innerHeight - 160 // Adjust based on the height of your modal

        let newX = e.clientX - offset.x
        let newY = e.clientY - offset.y

        newX = Math.max(0, Math.min(newX, maxX))
        newY = Math.max(0, Math.min(newY, maxY))

        setPosition({ x: newX, y: newY })
      }
    }

    const handleMouseUp = () => {
      setIsDragging(false)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging, offset])

  const handleMouseDown = (e) => {
    setIsDragging(true)
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    })
  }

  const clearLocalStorage = () => {
    localStorage.clear()
    sessionStorage.clear()
  }
  const removeCookies = () => {
    Cookies.remove('idcs_user_assertion')
    Cookies.remove('idcs_id_token')
    Cookies.remove('role')
    Cookies.remove('returnUrl')
  }

  const handleSignout = () => {
    const tokenId = getCookie('idcs_id_token');
    const roleCookie = getCookie('role');
    const roleStorage = getLocalStorageItem('role');
    const role = roleCookie || roleStorage;
    clearLocalStorage()
    removeCookies()
    const LogoutURLDev = `${process.env.REACT_APP_ANOTHER_API_URL}/logout?port=${window.location.port}&role=${role}&token-id=${tokenId}`
    const LogoutOther = `${process.env.REACT_APP_ANOTHER_API_URL}/logout?role=${role}&token-id=${tokenId}`
    const API_BASE_URL =
      process.env.NODE_ENV === "development" ? LogoutURLDev : LogoutOther
    removeCookies()
    setTimeout(() => {
      window.location.href = API_BASE_URL
    }, 1000)
  }

  if (!isOpen) return null
  return (
    <div className='p-3 inset-0 fixed z-50 bg-black bg-opacity-50 w-full min-h-screen'>
      <div
        className="modal-overlay fixed z-30 w-1/3 max-w-xl min-w-min text-sm
             bg-white shadow-lg shadow-black
             top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      // style={{ top: position.y, left: position.x }}
      >
        <div
          className='modal-container flex-col w-full'
        // onMouseDown={handleMouseDown}
        >
          <div className='modal-header flex float-right p-1'>
            <button
              className='modal-btnClose text-bold text-neutral-500'
              onClick={localStorage?.getItem('userData') ? onCancel : handleSignout}
            >
              &#10006;
            </button>
          </div>
          <div className='modal-content flex flex-col w-full py-2 justify-center'>
            <p className="text-xl font-bold text-center text-black mb-4">
              {SelectVendor}
            </p>
            <div className="px-4 max-h-60 overflow-y-auto my-2 space-y-3">
              {user && user?.map((u) => <label
                key={u?.supplierId}
                className="flex items-center gap-3 p-4 bg-white rounded-lg shadow hover:shadow-lg hover:bg-blue-50 transition-all cursor-pointer"
              >
                <input
                  type="radio"
                  name="vendor"
                  value={u?.supplierId}
                  onChange={(e) => onChangeRadio(e)}
                  defaultChecked={selected?.supplierId === u?.supplierId}
                />

                {/* Text container */}
                <div className="flex flex-col">
                  <span className="text-black font-semibold">{u?.supplierName} - {u?.supplierId}</span>
                  {/* <span className="text-gray-600 text-sm">
                    {u?.city}, {u?.country}
                  </span> */}
                </div>
              </label>)}
            </div>
            <div className='modal-buttons flex p-4 pb-4 align-middle w-full justify-center'>
              {<button
                onClick={localStorage?.getItem('userData') ? onCancel : handleSignout}
                className='modal-btnCancel w-40 m-2 p-3 border border-solid text-white bg-gray-500'
              >
                {Cancel}
              </button>}
              <button
                disabled={selectedVendor === ""}
                onClick={onConfirm}
                className='modal-btnConfirm w-40 m-2 p-3 border border-solid text-white bg-green-500'
              >
                {Confirm}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}
export default PopupModal